import { TrackingHistIconTypes } from "@hooks/functions/TrackingHist";
import {
  IAddressCityDTO,
  IAddressCountryDTO,
  IAddressStateDTO,
} from "./IAddressDTO";
import { TrackingHistStatusEnum } from "./ITrackingHistDTO";
import { ICustomerPublicDTO } from "./user-dto";

export enum TrackingStatusEnum {
  FINISHED = "f", // Delivered (Entregue)
  TRACKING = "t", // Tracking (Em Trânsito)
}

export type TrackingStatusTypes = `${TrackingStatusEnum}`;

export interface ITrackingStatusSelectDTO {
  status: TrackingStatusTypes;
  text: string;
}

export const trackingStatusSelect: ITrackingStatusSelectDTO[] = [
  {
    status: TrackingStatusEnum.TRACKING,
    text: "Em Trânsito",
  },
  {
    status: TrackingStatusEnum.FINISHED,
    text: "Entregue",
  },
];

export enum TrackingExternalStatusEnum {
  CREATED = "c",
  AGUARDANDO_CONCILIACAO = "ac",
  PENDENCIA_VALIDACAO = "pv",
  ENTREGUE = "en",
  CONTIGENCIADO = "co",
}

export type TrackingExternalStatusTypes = `${TrackingExternalStatusEnum}`;

export interface ITrackingDTO {
  id: number;
  track: number;
  code: number;
  customer: number;
  salesperson?: number;
  customerData: ICustomerPublicDTO;
  salespersonData: ICustomerPublicDTO;
  company?: string;
  shippingMethod?: string;
  companyTrackCode?: string;
  invoice?: string;
  cep: string;
  hood: string;
  street: string;
  number?: string;
  complement?: string;
  city: number;
  cityData?: IAddressCityDTO;
  state: number;
  stateData?: IAddressStateDTO;
  country: number;
  countryData?: IAddressCountryDTO;
  deliveryForecast?: Date;
  externalStatus: TrackingExternalStatusTypes;
  status: TrackingStatusTypes;
  createdAt: Date;
}

export interface ITrackingListDTO {
  id: number;
  code: number;
  customer?: number | ICustomerPublicDTO;
  company: string;
  customerName: string;
  shippingMethod: string;
  companyTrackCode: string;
  invoice?: string;
  cityName: string;
  stateIso: string;
  deliveryForecast?: Date;
  externalStatus: TrackingExternalStatusTypes;
  status: TrackingStatusTypes;
  createdAt: Date;
}

export interface ITrackingProgressBar {
  iconName: TrackingHistIconTypes;
  label: string;
  date: string;
  active: boolean;
  status: TrackingHistStatusEnum;
  color: string;
}
